import { Input, WebMInputFormat, Output, WebMOutputFormat, OggOutputFormat, BufferTarget, BlobSource, Conversion, QUALITY_HIGH } from "mediabunny";
const createOutput = (outputFormat) => {
    switch (outputFormat) {
        case "webm":
            return new Output({
                format: new WebMOutputFormat(),
                target: new BufferTarget()
            });
        case "ogg":
            return new Output({
                format: new OggOutputFormat(),
                target: new BufferTarget()
            });
        default:
            throw new Error(`Не поддерживаемый формат: ${outputFormat}`);
    }
};
export const convertBlob = async (recordedBlob, outputFormat, name) => {
    let convertRecordedFileData;
    try {
        const input = new Input({
            source: new BlobSource(recordedBlob),
            formats: [new WebMInputFormat()]
        });
        const output = createOutput(outputFormat);
        const conversion = await Conversion.init({
            input,
            output,
            audio: {
                bitrate: QUALITY_HIGH,
                codec: "opus",
                numberOfChannels: 1,
                sampleRate: 48000
            }
        });
        await conversion.execute();
        const arrayBuffer = output.target.buffer;
        if (arrayBuffer) {
            const type = await output.getMimeType();
            convertRecordedFileData = {
                file: new Blob([arrayBuffer], { type }),
                mimeType: output.format.mimeType,
                type,
                name,
                fullName: `${name}${output.format.fileExtension}`,
                extension: output.format.fileExtension
            };
        }
    }
    catch (error) {
        console.error("Ошибка при конвертации:", error);
    }
    return convertRecordedFileData;
};
export const setConvertedBlob = async (recordedBlob, setRecodedBlob, outputFormat, fileName) => {
    const fileData = recordedBlob
        ? await convertBlob(recordedBlob, outputFormat, fileName)
        : undefined;
    setRecodedBlob(fileData);
};
